<ng-container *transloco="let _t">
  
  
<div echarts #chart *ngIf="options.series.length>0 else nothing"
  [options]="options" class="canvas-holder"
  (chartClick)="onChartClick($event)"></div>
    
<ng-template #nothing>
<!--
  <p class="text-center vcenter" *ngIf="fullPage">
    <span>{{ _t('statistics-linechart-span-0') }} </span>
    <button mat-mini-fab color="disabled"><mat-icon>timeline</mat-icon></button>
    <br> <span>{{ _t('statistics-linechart-span-1') }}</span>
  </p>
-->
</ng-template>

</ng-container>
